import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { css } from '@emotion/react';
import { useWindowScrollDirection } from '../../../hooks/useWindowScrollDirection';
import { t } from '../../../domain/services/configService';
import { IconShareAndroid } from '../../Icon/IconShareAndroid';
import { IconShareIos } from '../../Icon/IconShareIos';
import { theme } from '../../../domain/theme';

export const ShareKitMobile = ({ handler, mobileOs }) => {
  const { y: directionY } = useWindowScrollDirection();
  const isGoingUp = directionY !== 'down';
  const [isForceVisible, setIsForceVisible] = useState(false);
  const setVisible = () => {
    setIsForceVisible(true);
  };
  useEffect(() => {
    // Event triggered by transporter
    document.addEventListener('gatsbyOnRouteUpdate', setVisible, {
      passive: true
    });
    return () => {
      document.removeEventListener('gatsbyOnRouteUpdate', setVisible, {
        passive: true
      });
    };
  }, []);
  useEffect(() => {
    let timeoutId;
    if (isForceVisible) {
      timeoutId = setTimeout(() => setIsForceVisible(false), 3000);
    }
    return () => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };
  }, [isForceVisible]);

  const isVisible = isForceVisible || isGoingUp;

  const styleShareKitContainerMobile = css`
    position: fixed;
    bottom: ${isVisible ? 0 : -58}px;
    right: 0;
    background: black;
    z-index: 100001;
    transition: all 0.35s ease;
    width: auto;
    padding: 16px;
  `;
  const styleMobileShareKitButton = css`
    border: none;
    background: none;
    color: white;
    ${theme.font.family('boldWeb')};
    font-size: 12px;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.5;
    letter-spacing: 3px;
    text-transform: uppercase;
    display: flex;
    align-items: center;
    &:focus {
      outline: none;
    }
    svg {
      display: block;
      width: 25px;
      overflow: auto;
      path {
        display: block;
      }
    }
  `;

  let IconComponent;
  switch (mobileOs) {
    case 'Ios':
      IconComponent = IconShareIos;
      break;
    case 'Android':
    default:
      IconComponent = IconShareAndroid;
      break;
  }

  return (
    <div css={styleShareKitContainerMobile}>
      <button css={styleMobileShareKitButton} type="button" onClick={handler}>
        <span
          css={css`
            margin-right: 12px;
            display: block;
            width: 100%;
          `}
        >
          {t('share')}
        </span>
        <IconComponent color="white" size={24} />
      </button>
    </div>
  );
};

ShareKitMobile.defaultProps = {
  handler: undefined,
  mobileOs: 'Android'
};
ShareKitMobile.propTypes = {
  handler: PropTypes.func,
  mobileOs: PropTypes.string
};
